export default __webpack_public_path__ + "static/pacman-sushiart-header-15e146a3205e9d052a82f74f2e998aa9.svg";